export default __webpack_public_path__ + "static/media/KFZKennzeichen.4c9cb78b.jpg";